import React, { useState } from "react";
import PageHeader from "../../../Component/BasicComponents/HeaderBreadCrumbs";
import RouteModal from "../../../Component/BasicComponents/Modal/RouteModal";
import BasicDataTable from "../../../Component/BasicComponents/BasicDataTable";
import { Btn } from "../../../AbstractElements";
import { FaEdit } from "react-icons/fa";
import { useAddOutComes, useGetOutcomesList, useUpdateOutcome } from "./useOutcome";
import ReusableDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import { useOutletTypesData } from "../../FSM/Subscriber/hooks/useSubscriber";
import { showToast } from "../../../utils/toastUtils";

type Props = {};

const OutComeColumn = (handleEdit: (row: any) => void) => [
  {
    name: "Type",
    selector: (row: { Type: string }) => row.Type,
  },
  {
    name: "Reason",
    selector: (row: { Reason: string }) => row.Reason,
  },
  {
    name: "Actions",
    maxWidth: "200px",
    cell: (row: any) => (
      <div className="d-flex align-items-center gap-2">
        <button
          className="btn btn-primary"
          onClick={()=>handleEdit(row)}
          style={{ borderRadius: "20px", padding: "5px", width: "80px" }}
        >
          <FaEdit size={18} style={{ fill: "#fff" }} /> Edit
        </button>
      </div>
    ),
  },
];

const OutCome = (props: Props) => {
  const [isModal, setIsModal] = useState(false);
  const [mode,setMode] = useState('add');
   
  // console.log('mode-------------------->',mode);

  const [filterData,setFilterData] = useState({
    page:1,
    limit:10,
    search:'',

    type:'',
    Resion:'',
    outletType:'',
    OutletOutcomeId:''
  })

  const { data:outletType } = useOutletTypesData({ enable: true });
  const {mutate:addOutcome}= useAddOutComes();
  const{mutate:updateOutcome} = useUpdateOutcome(); 
  const {data,isLoading,isSuccess} =useGetOutcomesList({enable:true, params:{
    page:filterData.page,
    limit:filterData.limit,
    search:filterData.search
  }})

  const handleEdit = (row:any) => {
    setIsModal(true);
    setMode('edit')

    setFilterData((prev:any)=>({
       ...prev,
      type:row.Type,
      Resion:row.Reason,
      outletType:row.OutletTypeId,
      OutletOutcomeId:row.OutletOutcomeId
    }))
  };

  const toggle = () => {
    setIsModal(!isModal);
    setFilterData((prev:any)=>({
      ...prev,
     type:'',
    Resion:'',
    outletType:''
    }))
  };
  const AddoutletOutcomes = () => {
    setIsModal(true);
    setMode('add');
  };

  const handleSubmit = () => {      
    
    if(mode === 'add'){
       
      if(filterData.type !=='' && filterData.outletType !=='' && filterData.Resion !="" ){
      const ReqBody={
      Type:filterData.type,
      Reason: filterData.Resion,
      OutletTypeId: Number(filterData.outletType)
      }
      addOutcome(ReqBody);
      setIsModal(false)
      setFilterData((prev:any)=>({
      ...prev,
    type:'',
    Resion:'',
    outletType:''
    }))
    return;
    }
    else{
      showToast.warning('Fill the Mandatory Fields')
    }
   } 
  
  if(mode === 'edit'){
     const ReqBody={
      Type:filterData.type,
      Reason: filterData.Resion,
      OutletTypeId: Number(filterData.outletType)
     }
     updateOutcome({ ReqBody:ReqBody, id: Number(filterData.OutletOutcomeId)});
     setIsModal(false);
     setFilterData((prev:any)=>({
    ...prev,
      type:'',
      Resion:'',
      outletType:''
     }))
      return;
  }
    

  };
  const handleSerach = (val:any)=>{
         setFilterData((prev:any)=>({
          ...prev,
          search:val
         }))
  }
  const handleOnChangeRowsPerPage=(limit:any,page:any)=>{
    
    setFilterData((prav:any)=>({
       ...prav,
       limit:limit,
       page:page
    }))

  }
  const handlePagination =(page:number)=>{
      setFilterData((prev:any)=>({
       ...prev,
       page:page
      }))
  }

  return (
    <div className="p-2">
      <PageHeader
        title="Outcome"
        buttons={[
          {
            label: "+Add outlet outcomes",
            onClick: AddoutletOutcomes,
          },
          {
            label: "Excle",
            onClick: () => alert("Add Excle"),
            color: "#43B9B2",
          },
          {
            label: "CSV",
            onClick: () => alert("Add CSV"),
            color: "#43B9B2",
          },
        ]}
      />

      <BasicDataTable
        Title="Outlet Outcomes"
        columns={OutComeColumn(handleEdit)}
        showSpinner={isLoading}
        data={(!isLoading && isSuccess && data.data) || []}
        paginationTotalRows={(!isLoading && isSuccess && data?.rowData?.data?.total) || 0}
        handleSearch={(val:any)=>handleSerach(val)}
         onChangeRowsPerPage={(newPerPage:any,page:any)=>handleOnChangeRowsPerPage(newPerPage,page)}
         onChangePage={(pageNo:number)=>handlePagination(pageNo)}
      />
      <RouteModal
        size="sm"
        toggle={toggle}
        isOpen={isModal}
        title={mode === 'add'?'Add OutCome':'Edit Outcome'}
        content={
          <form>
            <div className="row mb-0">
              <ReusableDropdown 
              asterisk
              DropdownHeading="Type"
              onChange={(opt)=>setFilterData((prev:any)=>({...prev,type:opt}))}
              options={[{id:'Skip',label:'Skip'},{id:'Reschedule',label:'Reschedule'}] } 
              value={filterData.type}
              />
               <div className="row mb-0 mt-4" >
                <label style={{
                fontWeight: "500",
                marginBottom: "6px",
                display: "block",
                marginTop: "10px",}}
                >Reasion<span style={{color:'red'}}>*</span> </label>
               <input 
               type="text"
               onChange={(e)=>setFilterData((prev:any)=>({...prev,Resion:e.target.value}))}
               value={filterData.Resion}
               required
               style={{
                 backgroundColor: 'transparent',
                 marginLeft: "12px",
                 borderRadius: 4,
                 border: '1px solid #d6d6d6',  
                 minHeight: "42px",
                 maxHeight: "120px",
                 width: "100%",
              }}
               />  
               </div>
              <ReusableDropdown
                asterisk
                DropdownHeading="Outlet Type"
                options={(outletType?.data) || []}
                onChange={(opt)=>setFilterData((prev:any)=>({...prev,outletType:opt}))}
                value={filterData.outletType}
            />
              <div className="d-flex justify-content-start gap-2 mt-4">
                <Btn
                  style={{ backgroundColor: "#43B9B2", color: "white" }}
                  onClick={handleSubmit}
                >
                  Submit
                </Btn>
                <Btn
                  onClick={toggle}
                  style={{ backgroundColor: "#F9FAFC", color: "#000" }}
                >
                  {""}
                  Cancil
                </Btn>
              </div>
            </div>
          </form>
        }
      />
    </div>
  );
};

export default OutCome;
